// extracted by mini-css-extract-plugin
module.exports = {"section":"HSection_section__ezx47","content":"HSection_content__6gaMD"};